import React from 'react';
import { useDarkMode } from '../darkmode/DarkModeContext';

const Promo = () => {
  const { isDarkMode } = useDarkMode();

  const promoOffers = [
    {
      title: 'Diskon Pelanggan Baru',
      description: 'Hemat hingga 50% untuk 3 bulan pertama',
      icon: '/image/icon_promo.png',
      color: 'from-[#1E9B4C] to-emerald-600'
    },
    {
      title: 'Gratis Instalasi',
      description: 'Bebas biaya pasang untuk kontrak 12 bulan',
      icon: '/image/icon_instalasi.png',
      color: 'from-emerald-600 to-teal-600'
    },
    {
      title: 'Paket Bundling',
      description: 'Internet + IPTV dengan harga spesial',
      icon: '/image/icon_paket.png',
      color: 'from-green-700 to-emerald-700'
    },
    {
      title: 'Upgrade Gratis',
      description: 'Upgrade kecepatan tanpa biaya tambahan',
      icon: '/image/icon_upgrade.png',
      color: 'from-emerald-500 to-green-600'
    }
  ];

  return (
    <section
      className="py-16 bg-cover bg-center transition-colors duration-300"
      style={{
        backgroundImage: "url('https://telnet.net.id/assets/bg.png')",
        backgroundColor: isDarkMode ? '#111827' : '#dfe4e0ff',
        backgroundBlendMode: 'overlay'
      }}
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className={`text-4xl font-bold mb-4 ${isDarkMode ? 'text-green-50' : 'text-gray-900'}`}>
            Promo & Penawaran Spesial
          </h2>
          <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-700'} text-lg max-w-2xl mx-auto`}>
            Dapatkan penawaran terbaik untuk paket internet pilihan Anda
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {promoOffers.map((offer, index) => (
            <div
              key={index}
              className={`
                promo-card bg-gradient-to-br ${offer.color}
                rounded-2xl p-6 text-white shadow-lg
                hover:translate-y-[-6px] hover:shadow-2xl transition-all
                ring-1 ring-white/10
              `}
            >
              <div className="flex justify-center">
                <img
                  src={offer.icon}
                  alt={offer.title}
                  className="w-26 h-26 mb-4 object-contain drop-shadow"
                  onError={(e) => {
                    // fallback simpel kalau ikon tak ditemukan
                    e.currentTarget.style.display = 'none';
                  }}
                />
              </div>

              <h3 className="text-xl font-bold mb-2 text-center">{offer.title}</h3>
              <p className="text-center text-white/90">{offer.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Promo;